import { ISalesOrdersDto } from "src/components/Pages/Documents/SalesOrders/dtos/ISalesOrdersDto";
import { AppEntities } from "../../config/entities";
import { DocumentService } from "./DocumentService";

export class CommodityWaybillsService extends DocumentService {
  async Clone(id: string) {
    const newObject = await this.Get(id);
    const clonedObject = { ...newObject };
    return clonedObject;
  }
//   async createBasedAtOrder(id: string) {
//     const orderDto = await AppEntities.VendorInvoices.getDataService().Get(id);
//     const newCustomerInvoice: ISalesOrdersDto = { ...orderDto };
//     // newCustomerInvoice.paymentOffsets = [];
//     return newCustomerInvoice;
//   }
}
